export default "__VITE_ASSET__CKh3TGBg__"